import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { ButtonStyled, Grid, GridItem, Image, TextStyled } from '@nike/nike-design-system-components';
import React from 'react';
import styled from '@emotion/styled';
import { useStadium } from 'stadium/StadiumHooks';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var GridWrapper = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media (min-width: 1920px) {\n    div.nds-grid-container {\n      margin-right: 0px !important;\n      margin-left: 0px !important;\n    }\n  }\n"])));
var GridItemPaddingRemoved = styled(GridItem)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: center;\n  @media (min-width: 1920px) {\n    padding-right: 0px !important;\n    padding-left: 0px !important;\n  }\n"])));
var Tile = function Tile(props) {
  var _useStadium = useStadium(),
    sendInteractionEvent = _useStadium.analyticsHooks.sendInteractionEvent;
  var _props$buttonLink = props.buttonLink,
    buttonLink = _props$buttonLink === void 0 ? '' : _props$buttonLink,
    buttonText = props.buttonText,
    placement = props.placement,
    _props$image = props.image,
    _props$image2 = _props$image === void 0 ? {} : _props$image,
    _props$image2$fileRef = _props$image2.fileReference,
    image = _props$image2$fileRef === void 0 ? '' : _props$image2$fileRef,
    title = props.title,
    description = props.description,
    newTabCheck = props.newTabCheck,
    mediaHost = props.mediaHost,
    linkHost = props.linkHost,
    xfPath = props.xfPath;
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  var href = buttonLink.includes('http') ? buttonLink : linkHost + buttonLink;
  var imageTag = /*#__PURE__*/_jsx(Image, {
    aspectRatio: "628/544",
    borderRadius: "none"
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    ,
    image: {
      src: image !== null && image !== void 0 && image.includes('http') ? image : mediaHost + image,
      alt: 'Nike'
    },
    "data-testid": "tile-image"
  });
  function renderImage() {
    if (buttonLink === '') return imageTag;
    return /*#__PURE__*/_jsx("a", {
      onClick: function onClick() {
        sendInteractionEvent("homepage:".concat(placement, ":").concat(xfPath, ":").concat(title, ":").concat(description, ":").concat(buttonText, ":").concat(buttonLink));
        return false;
      },
      "data-testid": "image-link",
      target: newTabCheck === 'true' ? '_blank' : '_self',
      href: href,
      role: "button",
      rel: "noreferrer",
      children: imageTag
    });
  }
  return /*#__PURE__*/_jsx(GridWrapper, {
    children: /*#__PURE__*/_jsxs(Grid, {
      exteriorGapXs: "0px",
      rowGapXs: "20px",
      placeholder: undefined,
      onPointerEnterCapture: undefined,
      onPointerLeaveCapture: undefined,
      children: [/*#__PURE__*/_jsx(GridItemPaddingRemoved, {
        xs: 12,
        children: renderImage()
      }), /*#__PURE__*/_jsx(GridItemPaddingRemoved, {
        xs: 12,
        children: /*#__PURE__*/_jsx(TextStyled, {
          appearance: "display4",
          align: "center",
          style: {
            font: 'var(--podium-cds-typography-320-to-959-display3)'
          },
          placeholder: undefined,
          onPointerEnterCapture: undefined,
          onPointerLeaveCapture: undefined,
          children: title
        })
      }), /*#__PURE__*/_jsx(GridItemPaddingRemoved, {
        xs: 12,
        children: /*#__PURE__*/_jsx(TextStyled, {
          appearance: "body2",
          align: "center",
          placeholder: undefined,
          onPointerEnterCapture: undefined,
          onPointerLeaveCapture: undefined,
          children: description
        })
      }), buttonText ? /*#__PURE__*/_jsx(GridItemPaddingRemoved, {
        xs: 12,
        children: /*#__PURE__*/_jsx(ButtonStyled, {
          onClick: function onClick() {
            sendInteractionEvent("homepage:".concat(placement, ":").concat(xfPath, ":").concat(buttonText, ":").concat(buttonLink));
            return false;
          },
          "data-testid": "tile-button",
          background: "light",
          appearance: "secondary",
          href: href,
          Component: "a",
          disabled: false,
          type: "button",
          disableRipple: false,
          placeholder: undefined,
          onPointerEnterCapture: undefined,
          onPointerLeaveCapture: undefined,
          children: buttonText
        })
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    })
  });
};
export default Tile;